import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'

import { HTTP_TIMEOUT_DEFAULT } from '@/configs/api'
import { ApiError, type ApiErrorBody } from './api-error'

const http = axios.create({
  timeout: HTTP_TIMEOUT_DEFAULT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

http.interceptors.response.use(
  (response) => {
    const data = response.data as { ok?: boolean } | null | undefined
    if (data && typeof data === 'object' && 'ok' in data && data.ok === false) {
      throw new ApiError(response.status, data as ApiErrorBody)
    }
    return response
  },
  (error: unknown) => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status ?? 0
      const body = (error.response?.data as ApiErrorBody | null) ?? null
      throw new ApiError(status, body, error.message)
    }
    throw new ApiError(0, null, (error as Error)?.message)
  },
)

export async function apiRequest<T = unknown>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return http.request<T>({
    ...config,
    headers: {
      ...http.defaults.headers.common,
      ...config.headers,
    },
  })
}

export { axios }
